// extracted by mini-css-extract-plugin
module.exports = {"imageWrap":"_2ALqu"};